export var ChecklistUnidadeFilterType;
(function (ChecklistUnidadeFilterType) {
    ChecklistUnidadeFilterType["CHECKLIST_UNIDADE_RECUSADO"] = "CHECKLIST_UNIDADE_RECUSADO";
    ChecklistUnidadeFilterType["CHECKLIST_UNIDADE_RECORRENTE"] = "CHECKLIST_UNIDADE_RECORRENTE";
    ChecklistUnidadeFilterType["CHECKLIST_UNIDADE_PLANO_ACAO"] = "CHECKLIST_UNIDADE_PLANO_ACAO";
})(ChecklistUnidadeFilterType || (ChecklistUnidadeFilterType = {}));
